// -----------------------------------------------------------------------------
// Plugin Includes
// -----------------------------------------------------------------------------
import Animate from './js-plugins/animate.js';
import jsLinkEvent from './js-plugins/js-link-event.js';

// -----------------------------------------------------------------------------
// Component Includes
// -----------------------------------------------------------------------------
import siteHeader from './components/site-header/site-header';
import testimonialSlider from './components/testimonial-slider/testimonial-slider';
import mobileMenu from './components/site-header/mobile-menu/mobile-menu';
import bookCarousel from './components/book-carousel/book-carousel';
import accordion from './components/accordion/accordion';
import newsArchive from './components/archive/archive';
import article from './components/article/article';
import moduleGrid from './components/module-grid/module-grid';
import logoGrid from './components/logo-grid/logo-grid';
import contactForm from './components/form/form.js';

const initializer = {
  components: [
    ['.site-header', siteHeader],
    ['.testimonial-slider', testimonialSlider],
    ['.mobile-menu', mobileMenu],
    ['.book-carousel', bookCarousel],
    ['.accordion', accordion],
    ['.archive', newsArchive],
    ['.article', article],
    ['.module-grid', moduleGrid],
    ['.logo-grid', logoGrid],
    ['.form', contactForm]
  ],
  plugins: [
    jsLinkEvent
  ]
};

class InkJS {

  constructor(initializer) {
    this.initializer = initializer;
    this.init();
  }

  init() {
    this.callAll(this.initializer.plugins);
    new Animate('[data-animation]');
    this.callAll(this.initializer.components, this.initComponent);
  }

  callAll(items, fn = (fn) => fn()) {
    items.forEach(fn);
  }

  initComponent([selector, handler]) {
    const $component = $(selector);

    if (!$component.length) {
      return null;
    }

    return $component.each((i, item) => {
      return handler(item);
    });
  }
}

(($) => {

  // Document Ready
  $(() => {
    new InkJS(initializer);
  });

})($);